import SpecialistPlan from "@feature/specialist-plan/specialist-plan";
import { memo } from "react";

export enum TaskSortEnum {
  DEFAULT,
  BY_START_DATE,
  BY_FINISH_DATE,
  BY_STATUS,
}

const SpecialistPlanPage = memo(() => {
  return (
    <main className="content-container">
      <div className="content-section">
        <SpecialistPlan />
      </div>
    </main>
  );
});

export default SpecialistPlanPage;
